// extracted by mini-css-extract-plugin
export var equalColumn = "_fx-0";